module.exports = __webpack_public_path__ + "static/media/Wheatfield.e707e469.png";